import { ArticleCard } from "../ArticleCard";

import { ArticleRecord } from "@features/articles/store";
import { paths } from "@features/routering/paths";
import {
  SliderSection,
  SliderSectionProps,
} from "@features/sections/components/SliderSection";
import Link from "next/link";
import React, { FC, memo, useMemo } from "react";

interface ArticlesSliderSectionProps
  extends Omit<SliderSectionProps, "items" | "cols" | "columnGap" | "rowGap"> {
  className?: string;
  style?: React.CSSProperties;
  data: ArticleRecord[];
}

const config = {
  cols: {
    desktop: 3,
    tablet: 2,
    mobile: 1,
  },
  columnGap: 15,
  rowGap: 37,
};

const _ArticlesSliderSection: FC<ArticlesSliderSectionProps> = (props) => {
  const { data, ...restProps } = props;

  const items = useMemo(() => {
    return data.map((article) => {
      return (
        <Link key={article.id} href={paths.articleDetail(article.id)}>
          <ArticleCard {...article} date={article.created_at} />
        </Link>
      );
    });
  }, [data]);

  return <SliderSection items={items} {...config} {...restProps} />;
};

export const ArticlesSliderSection = memo(_ArticlesSliderSection);
